import { FC, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { RootState } from '../../../store/rootReducer';
import useAxios from '../../../hooks/useAxios';

import { Table, TableColumnsType } from 'antd';


import Loader from '../../Loader';
import Button from '../../Button';
import ErrorResponse from '../../ErrorResponse';
import { getAttendance } from '../../../api/campusClasses2.api';
import moment from 'moment';
import { IGetAttendance } from '../../../models/campusClasses2.model';
import { getCommonCodeLabel } from '../../../lib/store';

interface IProps {
  setTab: (tab: string) => void;
}

const ClassAttendance: FC<IProps> = ({ setTab }) => {
  const { t } = useTranslation();
  const { chosenClass } = useSelector((state: RootState) => state.class);
  const { data: attendance, isLoading, error, execute } = useAxios<IGetAttendance>();

  const [memberKorName, setMemberKorName] = useState('');
  const [memberEngName, setMemberEngName] = useState('');
  const [classStudentCode, setClassStudentCode] = useState('');
  const [isRefundDisabled, setIsRefundDisabled] = useState(true);

  useEffect(() => {
    const _memberKorName = sessionStorage.getItem('memberKorName');
    const _memberEngName = sessionStorage.getItem('memberEngName');
    const _classStudentCode = sessionStorage.getItem('classStudentCode');
    if (_memberKorName) setMemberKorName(_memberKorName);
    if (_memberEngName) setMemberEngName(_memberEngName);
    if (_classStudentCode) setClassStudentCode(_classStudentCode);
  }, []);

  useEffect(() => {
    if (classStudentCode) {
      execute(getAttendance(classStudentCode));
    }
  }, [classStudentCode]);

  // 환불받지 않은 인정결석이 있으면, 관련 버튼 활성화
  useEffect(() => {
    if (attendance) {
      const data = attendance.data;
      for (let i = 0; i < data.length; i++) {
        if (data[i].attendStatus === 'NT' && data[i].refundYn !== 'Y') {
          setIsRefundDisabled(false);
          break;
        }
      }
    }
  }, [attendance]);

  const columns: TableColumnsType<any> = [
    {
      title: t('class.class.column42'),
      dataIndex: 'srtDate',
      key: 'srtDate',
      align: 'center',
      sorter: (a, b) => a.srtDate?.localeCompare(b.srtDate),
      render: (text: string) => moment(String(text)).format('YYYY.MM.DD'),
    },
    {
      title: t('class.class.column43'),
      dataIndex: 'lessonWeekDay',
      key: 'lessonWeekDay',
      align: 'center',
      sorter: (a, b) => a.lessonWeekday?.localeCompare(b.lessonWeekday),
      render: (text: string) => getCommonCodeLabel('SY0001', text, 'ko'),
    },
    {
      title: t('class.class.column34'),
      dataIndex: 'attendStatus',
      key: 'attendStatus',
      align: 'center',
      sorter: (a, b) => a.attendStatus?.localeCompare(b.attendStatus),
      render: (text: string) => getCommonCodeLabel('CL0001', text, 'ko'),
    },
    {
      title: t('class.class.column44'),
      dataIndex: 'memo',
      key: 'memo',
      align: 'center',
      sorter: (a, b) => a.memo?.localeCompare(b.memo),
    },
    {
      title: t('class.class.column45'),
      dataIndex: 'attachFile',
      key: 'attachFile',
      align: 'center',
      sorter: (a, b) => a.attachFile?.localeCompare(b.attachFile),
      render: (item: any) => {
        if (!item) return;
        return (
          <a
            className="download-link"
            href={`${item.fileLocation}`}
            download={item.originalName}
          >
            {item.originalName}
          </a>
        );
      },
    },
    {
      title: t("class.class.column46"),
      dataIndex: 'refundYN',
      key: 'refundYN',
      align: 'center',
      sorter: (a, b) => a.refundYn?.localeCompare(b.refundYn),
      render: (value, record) => {
        if (record.attendStatus === 'NT') {
          return value;
        }

        return 'N/A';
      }
    },
  ];

  return (
    <>
      {isLoading ? <Loader /> : null}
      <ErrorResponse error={error} />
      <div className="comm-bx__between">
        <h5 className='sub-title'>{chosenClass?.className}</h5>
        <div className="text-right">
          {memberKorName} ({memberEngName})
        </div>
      </div>
      <div className='comm-table__area'>
        <Table
          columns={columns}
          dataSource={attendance?.data}
          pagination={{
            pageSize: 99999
          }}
          rowKey="classStudentCode"
        />
      </div>
      <div className="comm-bx__between">
        <div className="comm-btn__area ">
          <Button
            className="btn-basic gray-line"
            onClick={() => setTab('register')}
            text={t('common.button.back')}
          />
        </div>
        <div className="comm-btn__area right">
          <Button
            className="btn-basic pink-line"
            onClick={() => setTab('refund')}
            text={t('class.class.button7')}
            disabled={isRefundDisabled}
          />
        </div>
      </div>
    </>
  );
}

export default ClassAttendance;
